<template>
    <div class="absolute top-3 right-4">
        <button type="button"
            class="outline-none appearance-none border border-a-gray-333333 rounded-full px-4 py-1.5 text-13 text-normal"
            @click="confirmPopup">
            {{ lbl.buttons.logout }}
        </button>
    </div>
</template>

<script>
import { inject } from 'vue';
import useAlertModal from "@/module/TheOne/composable/useAlertModal"

export default {
    name: "BtnLogout",
    setup: function () {
        const { lbl } = inject("LocaleStore")
        const modalStore = inject("ModalStore")
        const { showApiErrorModal } = useAlertModal(modalStore)
        const theOneService = inject("TheOneService")

        return {
            lbl,
            modalController: modalStore.methods.getModalController(),
            theOneService,
            showApiErrorModal
        }
    },
    methods: {
        confirmPopup: function () {
            this.modalController.confirmModal
                .clearModal()
                .setTitle(this.lbl.logout.title)
                .setMsg(this.lbl.logout.text)
                .onClickOk(() => {
                    // call logout
                    this.callLogout()
                })
                .show({
                    btnOk: this.lbl.logout.btnOk,
                    btnCancel: this.lbl.logout.btnCancel
                })
        },
        callLogout: function () {
            this.modalController.loadingModal.show()
            this.theOneService.methods.logout().then((res) => {
                console.log(res)
                this.$router.go()
            }).catch((err) => {
                console.log(err)
                this.showApiErrorModal("Logout error", err, {
                    errCode: err.code
                })
            }).finally(() => {
                this.modalController.loadingModal.hide()
            })
        }
    }
}
</script>

<style lang="scss" scoped>
@import "@/module/TheOne/style/base.scss";
</style>
